const data = {};

data.checkExchange = {
  data: {
    code: 0, // success
    // code: -1, // error
    // code: 3017, // 회원 DB이름과 계좌주명 불일치
    message: 'success',
    data: null,
    debug: null,
  },
  // data: {
  //   "code": 3006,
  //   "message": "현금 캐시백은 월 1회 신청이 가능합니다.<br />이번 달에 이미 신청하신 내역이 있어 신청이 불가능합니다.<br />신청하신 내용은 포인트 전환 내역에서 확인해주세요.",
  //   "data": null,
  //   "debug": {}
  // }
};
data.exchangeInfo = {
  data: {
    code: 0, // success
    // code: -1, // error
    message: 'success',
    data: {
      currency: 'USD',
      exchangeRate: 1000,
      exchangeMinAmount: 1000,
      exchangeMaxAmount: 10000000,
      exchangeAmountUnit: 1000,
      secondExchangeRate: 1114,
      exchangeNotice: '포인트 전환 신청 안내 예시',
    },
  },
  debug: null,
};

data.exchangeNexonPointInfo = {
  data: {
    code: 0,
    message: 'success',
    data: {
      currency: 'P',
      exchangeRate: 1,
      secondExchangeRate: 1,
      exchangeMinAmount: 50000,
      exchangeMaxAmount: 10000000,
      exchangeAmountUnit: 1000,
      exchangeNotice: '넥슨 포인트 전환 신청 안내 예시',
    },
  },
  debug: null,
};
data.bankList = {
  data: {
    code: 0,
    message: 'success',
    data: {
      bankList: [
        {
          bankCode: '100',
          bankName: '은행0',
        },
        {
          bankCode: '101',
          bankName: '은행1',
        },
        {
          bankCode: '102',
          bankName: '신한',
        },
      ],
    },
    debug: null,
  },
  // data: {
  //   "code": -1,
  //   "message": "은행코드조회 실패",
  //   "data": null,
  //   "debug": { 에러 관련 }
  // }
};
data.exchangeInit = {
  data: {
    code: 0, // success
    // code: -1, // error
    // code: -1, // error
    message: 'success',
    data: {
      zipCode: '12356',
      address1: '서울시 어쩌구 저쩌구',
      address2: '205번지',
      telNo: '02-1234-5678',
      userName: '강*엽',
      bankName: '신한',
      accountNo: '123123123',
      // isCheckedIdNo: true,
      isCheckedIdNo: false,
      isCheckedAccountNo: true,
      first: true,
      businessType: 1,
    },
    debug: null,
  },
};
data.setExchangeAccountRegist = {
  data: {
    code: 0,
    message: 'success',
    data: {
      bankCode: '101',
      accountNo: '123***123',
    },
    debug: null,
  },
  // data: {
  //   "code": -1,
  //   "message": "에러메세지",
  //   "data": null,
  //   "debug": { 에러 관련 }
  // }
};
data.exchangeRequest = {
  data: {
    code: 0, // success
    // code: -1, // error
    message: 'success',
    data: null,
    debug: null,
  },
  // data: {
  //   "code": 3006,
  //   "message": "현금 캐시백은 월 1회 신청이 가능합니다.<br />이번 달에 이미 신청하신 내역이 있어 신청이 불가능합니다.<br />신청하신 내용은 포인트 전환 내역에서 확인해주세요.",
  //   "data": null,
  //   "debug": { 에러 관련 }
  // }
};

// NJ 넥슨 포인트 전환 신청
data.exchangeNexonPointRequest = {
  data: {
    code: 0,
    message: 'success',
    data: {
      orderID: 'nexonpoint021220250210195019174_B0083F48',
      usageSn: '4839',
    },
    debug: null,
  },
};

data.exchangeHistory = {
  data: {
    code: 0,
    message: 'success',
    data: {
      totalCount: 200,
      totalPageCount: 20,
      pageNo: 2,
      pageSize: 10,
      list: [
        {
          content: {
            chargeTypeName: 'cancelRequestExchangePoint',
            extraInfo: '신청',
            regDate: '2023.04.01',
          },
          expiryDate: null,
          exchangeNo: 'WDL020220221006150553893',
          regDate: '2022.10.06 15:05:53',
          exchangePoint: 50000,
          exchangeStatus: 3,
          exchangeStatusName: '지급취소',
          usePoint: 50000,
          paymentDate: null,
          reason: null,
          requestAmount: 50000,
          finalAmount: 50000,
          actualAmount: 50000,
          feeAmount: 0.0,
          taxAmount: 0.0,
          accountOwnerName: '강*엽',
          bankName: 'KEB하나은행',
          accountNo: '123*****90',
          businessType: 1,
          liabilityType: null,
          savePeriod: '',
          rate: null,
          taxInvoiceDate: '',
          taxInvoiceDeadline: null,
          businessName: null,
          withdrawalType: 2,
          userType: 1,
        },
        {
          content: {
            chargeTypeName: 'cancelRequestExchangePoint',
            extraInfo: '신청',
            regDate: '2023.04.01',
          },
          expiryDate: null,
          exchangeNo: 'WDL020220221006150553893',
          regDate: '2022.10.06 15:05:53',
          exchangePoint: 50000,
          exchangeStatus: 2,
          exchangeStatusName: '처리준비중',
          usePoint: 50000,
          paymentDate: null,
          reason: null,
          requestAmount: 50000,
          finalAmount: 50000,
          actualAmount: 50000,
          feeAmount: 0.0,
          taxAmount: 0.0,
          accountOwnerName: '강*엽',
          bankName: 'KEB하나은행',
          accountNo: '123*****90',
          businessType: 1,
          liabilityType: null,
          savePeriod: '',
          rate: null,
          taxInvoiceDate: '',
          taxInvoiceDeadline: null,
          businessName: null,
          withdrawalType: 2,
          userType: 1,
        },
        {
          content: {
            chargeTypeName: 'cancelRequestExchangePoint',
            extraInfo: '신청',
            regDate: '2023.04.01',
          },
          expiryDate: null,
          exchangeNo: 'WDL020220221006150553893',
          regDate: '2022.10.06 15:05:53',
          exchangePoint: 50000,
          exchangeStatus: 5,
          exchangeStatusName: '지급완료',
          usePoint: 50000,
          paymentDate: null,
          reason: null,
          requestAmount: 50000,
          finalAmount: 50000,
          actualAmount: 50000,
          feeAmount: 0.0,
          taxAmount: 0.0,
          accountOwnerName: '강*엽',
          bankName: 'KEB하나은행',
          accountNo: '123*****90',
          businessType: 1,
          liabilityType: null,
          savePeriod: '',
          rate: null,
          taxInvoiceDate: '',
          taxInvoiceDeadline: null,
          businessName: null,
          withdrawalType: 2,
          userType: 1,
        },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 1,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 6,
        //   "exchangeStatusName": "처리 실패",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-08",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 2,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 2,
        //   "exchangeStatusName": "처리 준비중",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 2,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 5,
        //   "exchangeStatusName": "처리 완료",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 2,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 6,
        //   "exchangeStatusName": "처리 실패",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "00가 부족합니다."
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 2,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-25",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // },
        // {
        //   "userType": 1,
        //   "widthdrawalType": 1,
        //   "exchangeNo": "12",
        //   "regDate": "2020-05-01",
        //   "content": "전환내역0",
        //   "liabilityType": "포인트종류",
        //   "savePeriod": "적립기간",
        //   "rate": 1,
        //   "usePoint": 11,
        //   "exchangeStatus": 1,
        //   "exchangeStatusName": "신청",
        //   "paymentDate": "2020-10-10",
        //   "accountOwnerName": "계*주",
        //   "bankName": "신한",
        //   "accountNo": "12312312-312312312",
        //   "feeAmount": 16,
        //   "taxAmount": 16,
        //   "finalAmount": 15,
        //   "requestAmount": 14,
        //   "actualAmount": 16,
        //   "exchangePoint": 1000000,
        //   "taxInvoiceDate": "2020-05-01",
        //   "taxInvoiceDeadline": "2020-05-08",
        //   "businessName": "업체명",
        //   "reason": "사유"
        // }
      ],
    },
    debug: null,
  },
};

data.checkGlobalExchange = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};
data.checkGlobalExchangeNexonPoint = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
};

data.globalExchangeHistory = {
  data: {
    code: 0,
    message: 'success',
    data: {
      totalCount: 12,
      totalPageCount: 2,
      pageNo: 1,
      pageSize: 10,
      list: [
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830405',
          amount: 10000,
          currencyAmount: 50,
          status: 0,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830406',
          amount: 20000,
          currencyAmount: 50,
          status: 1,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830407',
          amount: 30000,
          currencyAmount: 50,
          status: 31,
          withdrawalType: 6, // 넥슨포인트
          refCurrency: 'P',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830407',
          amount: 40000,
          currencyAmount: 50,
          status: 32,
          withdrawalType: 6, // 넥슨포인트
          refCurrency: 'P',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830405',
          amount: 50000,
          currencyAmount: 50,
          status: 2,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830406',
          amount: 60000,
          currencyAmount: 50,
          status: 3,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830407',
          amount: 70000,
          currencyAmount: 50,
          status: 11,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830407',
          amount: 80000,
          currencyAmount: 50,
          status: 2,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830405',
          amount: 90000,
          currencyAmount: 50,
          status: 1,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830406',
          amount: 100000,
          currencyAmount: 50,
          status: 2,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830407',
          amount: 110000,
          currencyAmount: 50,
          status: 3,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
        {
          regDate: '2023.05.26 17:09:33 (UTC +8)',
          orderId: 'EXCH001684830407',
          amount: 120000,
          currencyAmount: 50,
          status: 1,
          withdrawalType: 3,
          refCurrency: 'USD',
        },
      ],
    },
    debug: null,
  },
};

data.krpcNotice = {
  data: {
    code: 0,
    message: 'success',
    data: {
      withdrawNotice: `
        <h3>KRPC 한국 유저 포인트 전환 안내 사항 예시</h3>
        <ul>
          <li>- 포인트는 어쩌구 저쩌구1</li>
          <li>- 포인트는 어쩌구 저쩌구2</li>
          <li>- 포인트는 어쩌구 저쩌구3</li>
        </ul>
      `,
    },
  },
};

data.globalNotice = {
  data: {
    code: 0,
    message: 'success',
    data: {
      withdrawPolicy: `
        <ul>
          <li>글로벌 출금정책 어쩌구 저쩌구1</li>
          <li>글로벌 출금정책 어쩌구 저쩌구2</li>
          <li>글로벌 출금정책 어쩌구 저쩌구3</li>
        </ul>
      `,
      withdrawNotice: `
        <ul>
          <li>- 글로벌 출금안내 어쩌구 저쩌구1</li>
          <li>- 글로벌 출금안내 어쩌구 저쩌구2</li>
          <li>- 글로벌 출금안내 어쩌구 저쩌구3</li>
        </ul>
      `,
      njPointWithdrawNotice: `
        <ul>
          <li>- NJ포인트 출금안내 어쩌구 저쩌구1</li>
          <li>- NJ포인트 출금안내 어쩌구 저쩌구2</li>
          <li>- NJ포인트 출금안내 어쩌구 저쩌구3</li>
        </ul>
      `,
    },
  },
};

data.reserveWithdraw = {
  data: {
    code: 0,
    message: 'success',
    data: {
      orderID: 'EXCH001684830405',
      iframeURL:
        'https://ui2.sandbox.tipalti.com/payeedashboard/home?payer=NxK&idap=72&ts=1684830489&uiculture=ko&redirectto=https://abc.xyx.com/result?orderId=EXCH001684830405&preferredPayerEntity=RP-HIT2-Global&hashkey=d30c835ddc083c092ad6d1e13b3c59b651774ed38c4a1a716ebb08da8587ed9d',
    },
    debug: null,
  },
};

export default {
  ...data,
};
